module.exports = __webpack_public_path__ + "img/host.4a8493d3.png";